import { throttle } from 'lodash-es'
import { provide } from 'vue'
import { PAGE_EDIT_SCROLL_INJECTION_KEY } from '../../../tokens/index'

export function useScroll() {
  const onScrolls = []
  const scroll = throttle((event) => {
    for (const onScroll of onScrolls) {
      onScroll(event)
    }
  }, 100)

  provide(PAGE_EDIT_SCROLL_INJECTION_KEY, {
    onPageEditScroll(fn) {
      onScrolls.push(fn)
    },
  })

  return {
    scroll,
  }
}
